import withSSRModel from "hoc-lib/ssrModelMapper"
import { withSpacing } from "hoc-lib/spacing"
import BreadcrumbStandalone from "./BreadcrumbStandalone"

const WrappedComponent = withSSRModel(withSpacing()(BreadcrumbStandalone))

// Component has to be mapped by the consumer
// Config has to be imported from constants-lib and passed to the MapTo function by the consumer
export default WrappedComponent
